import { Injectable } from '@angular/core';
import { ConfigurationService } from '@app/app-initialisers/configuration-service/configuration.service';
import { VisualSubTheme } from '@app/models/theme/visual-sub-theme';
import { Subscription } from 'rxjs';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { VisualTheme } from '@app/models/theme/visual-theme';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  constructor(private configurationService: ConfigurationService, private readonly http: HttpClient) {}

  /**
   * Initializes the theme service, updates the css variables to use colours from the tenants branding visual theme.
   * @returns A subscription to the tenant readiness status.
   */
  public loadTheme(): Subscription {
    return this.configurationService.isTenantReady.subscribe((status: boolean) => {
      if (status) {
        if (environment.useMockTheme) {
          this.http.get<object>('assets/_dev-assets/custom-theme.json').subscribe((data: object) => {
            const mockTheme: VisualTheme = data['SushiCo'].VisualTheme;
            this.setCssVariables(mockTheme.Light);
          });
        } else {
          const theme: VisualTheme = this.configurationService.getTenantVisualTheme();
          this.setCssVariables(theme.Light);
        }
      }
    });
  }

  private setCssVariables(theme: VisualSubTheme): void {
    const root: HTMLElement = this.getRootElement();

    for (const [key, value] of Object.entries(theme)) {
      root.style.setProperty(`--on-${key.toLowerCase()}-color`, value.Foreground);
      root.style.setProperty(`--${key.toLowerCase()}-color`, value.Background);
    }
  }

  private getRootElement(): HTMLElement {
    return document.documentElement;
  }
}
